export const dialogErrorConfig = {
  closeOnEscape: false,
  acceptButtonStyleClass: 'p-button-secondary',
  rejectVisible: false,
  acceptIcon: 'hide',
  acceptLabel: 'ตกลง'
};
